import { cn } from "@/lib/utils"
import type { ChipTone, OfferChip } from "../types"

const TONE: Record<ChipTone, string> = {
  default: "border border-purple-light/20 text-purple-light/70",
  purple: "bg-main-purple/10 text-main-purple",
  peach: "bg-peach/10 text-peach",
  cyan: "bg-cyan/10 text-cyan",
  green: "bg-green/10 text-green",
  gold: "bg-gold/10 text-gold",
}

/** Tag pill used in the offer feature cards (icon + label, bordered or tinted). */
export function OfferSkillChip({ chip }: { chip: OfferChip }) {
  return (
    <div
      data-slot="offer-skill-chip"
      className={cn(
        "flex items-center justify-center gap-1 rounded-[23px] py-1.5 pl-2 pr-3",
        TONE[chip.tone ?? "default"],
      )}
    >
      <img src={chip.icon} alt="" className="size-[18px] shrink-0" />
      <span className="whitespace-nowrap text-sm">{chip.label}</span>
    </div>
  )
}
